import React from "react";
import styled, { withTheme } from "styled-components";
import { Button } from "../../ui-library/AuthControls/Button";

const Subtitle = styled.p`
  font-weight: 600;
  color: ${(props) => props.theme?.nero};
  opacity: 0.63;
`;

const LoggedOut = (props) => {
  const { handleSubmit, modalSubtitle, modalButtonText } = props;

  return (
    <form
      onSubmit={handleSubmit}
      className="auth-form"
      data-testid="logged-out"
    >
      <Subtitle>{modalSubtitle}</Subtitle>
      <Button text={modalButtonText} />
    </form>
  );
};

export default withTheme(LoggedOut);
